import { z } from 'zod';
import { SubscriptionConsumableFeatures, SubscriptionConsumablePeriods, SubscriptionPlanPeriods, } from '../../enums/Subscription';
import { BaseSchema } from '../BaseSchema';
import { CustomerSchema } from '../Customer/Customer';
export var SubscriptionPlanSchema = BaseSchema.extend({
    name: z.string().min(1),
    internalTags: z.string().array().optional().nullable(),
    listed: z.boolean(),
    customer: z.union([z.string(), CustomerSchema]).optional().nullable(),
    order: z.number(),
    consumableFeatures: z.object({
        name: z.nativeEnum(SubscriptionConsumableFeatures),
        amount: z.number().nullable().transform(function (v) { return v === null ? Infinity : v; }),
        periodicity: z.nativeEnum(SubscriptionConsumablePeriods)
    }).array(),
    planPeriodicity: z.nativeEnum(SubscriptionPlanPeriods),
    planPeriodicityQuantity: z.number(),
    unavailableActions: z.string().array().optional().nullable(),
    currencyBasedPrices: z.record(z.number()).optional()
});
